import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { Banner } from "../../shared/models/banner";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { MatExpansionModule, MatExpansionPanel } from "@angular/material/expansion";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";



@Component({
    selector: "div.dtf-calculatorpage",
    imports: [SharedTranslateModule,SessionTimeoutComponent, MatTableModule, ReactiveFormsModule, MatExpansionModule, MatExpansionPanel, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule],
    templateUrl: './calculator.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class CalculatorComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  isFrench = false;
  isCanadaFrench = false;
  isCanadaEnglish = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  tableLoaded = true;
  openLoginModal = false;
  calculatorForm: FormGroup;
  salesPrice:any;
	downPayment:any;
	salesTaxRate:any;
	interestRate:any;
	financingPeriod:any;
	desiredMonthlyPayment:any;
  monthlyPayment:any;
  maxCost:any;
  ShowMaxCost = false;
  ShowMonthlyPayment =false;

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil,
    public auth: AuthorizationService,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.isCanadaEnglish = this.isCanadaPortal && !this.isFrench;
      this.isCanadaFrench = this.isCanadaPortal && this.isFrench;
      this.cdRef.detectChanges();
    });
    //this.getAlerts();
    this.langInit();
    let element: HTMLElement = document.getElementById('auto_triggercalculator') as HTMLElement;
    element.click();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.targetRedirect = this.usUrl + '/ca/en/home/';
    } else if (this.language === 'fr-CA') {
        this.targetRedirect = this.usUrl + '/ca/fr/home/';
    } else {
        this.targetRedirect = this.usUrl + '/home/';
    }
  }

  getCalculator(calculatortype: any){
    this.ShowMaxCost = false;
    this.ShowMonthlyPayment =false;
    let CalculatorRequest = {};
    if(calculatortype === "afford"){
      CalculatorRequest = {
        salesPrice: 0,
        downPayment: this.downPayment,
        salesTaxRate : this.salesTaxRate,
        interestRate: this.interestRate,
        financingPeriod: this.financingPeriod,
        desiredMonthlyPayment: this.desiredMonthlyPayment
      }
    }
    else{
      CalculatorRequest = {
        salesPrice: this.salesPrice,
        downPayment: this.downPayment,
        salesTaxRate : this.salesTaxRate,
        interestRate: this.interestRate,
        financingPeriod: this.financingPeriod,
        desiredMonthlyPayment: 0
      }
    }
    this.tableLoaded = false; //Spinner enabler
    this.cdRef.detectChanges();
    this.auth.getCalculator(CalculatorRequest).subscribe(res => {
      this.monthlyPayment=res.monthlyPayment;
      this.maxCost=res.maxCost;
      if(calculatortype === "afford"){
        this.ShowMaxCost = true;
      }
      else{
        this.ShowMonthlyPayment = true;
      }
      this.tableLoaded = true; //Spinner disabled
      this.cdRef.detectChanges();
    }, () => {
      this.tableLoaded = true;
      this.cdRef.detectChanges();
    }); 
  }
  clearCalculator(){
    this.salesPrice= 0;
    this.downPayment = 0;
    this.salesTaxRate = 0;
    this.interestRate= 0;
    this.financingPeriod= 0;
    this.desiredMonthlyPayment = 0;
    this.monthlyPayment=0;
    this.maxCost=0;
    this.ShowMaxCost = false;
    this.ShowMonthlyPayment =false;
  }
  onClickCalculator(e: Event): void {
    this.buildForm();
    this.openLoginModal = true;
    this.calculatorForm.get('salesPrice').setValidators(
      Validators.compose([Validators.required])
    );
    this.calculatorForm.get('downPayment').setValidators(
      Validators.compose([Validators.required])
    );
    this.calculatorForm.get('salesTaxRate').setValidators(
      Validators.compose([Validators.required])
    );
    this.calculatorForm.get('interestRate').setValidators(
      Validators.compose([Validators.required])
    );
    this.calculatorForm.get('financingPeriod').setValidators(
      Validators.compose([Validators.required])
    );
    this.calculatorForm.get('desiredMonthlyPayment').setValidators(
      Validators.compose([Validators.required])
    );

  }

  buildForm() {
    this.calculatorForm = this.fb.group({
      salesPrice: [''],
      downPayment: [''],
      salesTaxRate: [''],
      interestRate: [''],
      financingPeriod: [''],
      desiredMonthlyPayment: ['']
    });
  }


  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     });
  // }


}
